var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTermsConditions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1167 36.6668C12.4633 36.6668 9.135 36.6668 7.06667 34.7135C5 32.7618 5 29.6185 5 23.3335V16.6668C5 10.3818 5 7.2385 7.06667 5.28683C9.135 3.3335 12.4633 3.3335 19.1167 3.3335H20.8833C27.5383 3.3335 30.865 3.3335 32.9333 5.28683C35 7.2385 35 10.3818 35 16.6668M19.1667 36.6668H21.6667M13.3333 11.6668H26.6667M13.3333 20.0002H21.6667",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 30.9837L27.6634 36.2387C27.6482 36.2983 27.6498 36.3609 27.6681 36.4196C27.6863 36.4783 27.7204 36.5308 27.7667 36.5714C27.8129 36.6119 27.8694 36.6389 27.93 36.6493C27.9906 36.6597 28.0529 36.6531 28.11 36.6303L31.4184 35.3087C31.5777 35.2447 31.7556 35.2447 31.915 35.3087L35.255 36.642C35.3109 36.6643 35.3718 36.671 35.4312 36.6615C35.4906 36.652 35.5463 36.6266 35.5925 36.588C35.6386 36.5494 35.6734 36.499 35.6932 36.4422C35.713 36.3854 35.7171 36.3243 35.705 36.2653L34.4317 30.8187M36.6667 26.6587C36.6645 25.334 36.1367 24.0644 35.1993 23.1285C34.2618 22.1926 32.9913 21.667 31.6667 21.667C28.905 21.667 26.6667 23.902 26.6667 26.6587C26.6671 27.3148 26.7968 27.9643 27.0483 28.5703C27.2999 29.1763 27.6683 29.7267 28.1326 30.1903C28.5969 30.6538 29.148 31.0213 29.7544 31.2719C30.3608 31.5224 31.0106 31.651 31.6667 31.6503C34.4284 31.6503 36.6667 29.417 36.6667 26.6587Z",
    stroke: "#333333",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsConditions);
export default __webpack_public_path__ + "static/media/TermsConditions.2e45970636a70292d4769f2866de3357.svg";
export { ForwardRef as ReactComponent };